import { useDispatch, useSelector } from 'react-redux';
import { AppState, AppDispatch } from '../store';
import {
  learningMaterialListSuccessPayload,
  createLearningMaterial,
  fetchingLearningMaterialList,
  getLearningMaterialDetail,
  updateLearningMaterial,
  generateLearningMaterial,
  fetchingLearningMaterialListV2,
  fetchingContentCreatorList,
} from '../store/actions/learningMaterialActions';

import { clearLearningMaterialData } from '@store/reducers/learningMaterialReducer';

type learningMaterialDataDetailType = Omit<
  learningMaterialListSuccessPayload,
  'id' | 'status' | 'created_date' | 'updated_date'
>;

export const useLearningMaterial = () => {
  const dispatch: AppDispatch = useDispatch();
  const learningMaterialList = useSelector(
    (state: AppState) => state.learningMaterial.learningMaterialList,
  );
  const learningMaterialCreation = useSelector(
    (state: AppState) => state.learningMaterial.learningMaterialCreation,
  );
  const loading = useSelector(
    (state: AppState) => state.learningMaterial.loading,
  );
  const success = useSelector(
    (state: AppState) => state.learningMaterial.success,
  );
  const contentCreatorList = useSelector(
    (state: AppState) => state.learningMaterial.contentCreatorList,
  );

  const fetchLearningMaterialData = (filters: any) => {
    dispatch(fetchingLearningMaterialList(filters));
  };

  const fetchLearningMaterialDataV2 = (filters: any) => {
    dispatch(fetchingLearningMaterialListV2({ filters }));
  };

  const getLearningMaterialDetailAction = (id?: string) => {
    dispatch(getLearningMaterialDetail(id));
  };

  const createLearningMaterialAction = (
    data: learningMaterialDataDetailType,
  ): any => {
    return dispatch(createLearningMaterial(data));
  };

  const clearLearningMaterialAction = () => {
    dispatch(clearLearningMaterialData());
  };

  const updateLearningMaterialAction = (
    data: learningMaterialDataDetailType,
    id: string,
  ): void => {
    dispatch(updateLearningMaterial(data, id));
  };

  const generateLearningMaterialAction = (
    data: learningMaterialDataDetailType,
    file_url: string,
    user: any,
  ): void => {
    dispatch(generateLearningMaterial(data, file_url, user));
  };

  const fetchContentCreatorListAction = (filters: any) => {
    dispatch(fetchingContentCreatorList(filters));
  };

  return {
    loading,
    success,
    learningMaterialList,
    learningMaterialCreation,
    fetchLearningMaterialData,
    fetchLearningMaterialDataV2,
    getLearningMaterialDetailAction,
    createLearningMaterialAction,
    updateLearningMaterialAction,
    clearLearningMaterialAction,
    generateLearningMaterialAction,
    fetchContentCreatorListAction,
    contentCreatorList,
  };
};
